export const affiliateReferenceArabic = {
  'Affiliates': 'الإحالات',
  'Referral program': 'برنامج الإحالات',
  'Referral statistics': 'إحصاءات الإحالات',
  'Referral link': 'رابط الإحالة',
  'Commission rate': 'نسبة العمولة',
  'Minimum payout': 'الحد الأدنى للسحب',
  'Total visits': 'إجمالي الزيارات',
  'Registrations': 'التسجيلات',
  'Referrals': 'العملاء المُحالون',
  'Conversion rate': 'نسبة التحويل',
  'Total earnings': 'إجمالي الأرباح',
  'Unpaid earnings': 'الأرباح غير المدفوعة',
  'Copy link': 'نسخ الرابط',
  'Payouts and history': 'السحب والسجل',
  'Program rules': 'شروط البرنامج',
  'Available': 'المتاح',
  'Reserved': 'المحجوز',
  'Reversed': 'العمولات المعكوسة',
  'Paid manually': 'المدفوع يدويًا',
  'Payout amount in USD': 'مبلغ السحب بالدولار الأمريكي',
  'Request manual payout': 'طلب سحب يدوي',
  'Retry same payout request': 'إعادة محاولة طلب السحب نفسه',
  'Payout history': 'سجل السحب',
  'No payout requests yet.': 'لا توجد طلبات سحب حتى الآن.',
  'Referral link copied.': 'تم نسخ رابط الإحالة.',
  'Clipboard is unavailable. Copy the displayed link manually.': 'الحافظة غير متاحة. انسخ الرابط الظاهر يدويًا.',
  'Loading affiliate policy...': 'جارٍ تحميل سياسة الإحالات…',
  'Loading earnings...': 'جارٍ تحميل الأرباح…',
  'Retry policy': 'إعادة تحميل السياسة',
  'Retry earnings': 'إعادة تحميل الأرباح',
  'Earnings could not be loaded. Retry.': 'تعذّر تحميل الأرباح. أعد المحاولة.',
  'The affiliate program has not been configured for this panel.': 'لم يُضبط برنامج الإحالات لهذه اللوحة بعد.',
  'New referrals are disabled.': 'الإحالات الجديدة معطلة.',
  'New referrals and payout requests are disabled. Existing earnings remain visible.': 'الإحالات الجديدة وطلبات السحب معطلة. تبقى الأرباح السابقة ظاهرة.',
  'Visit tracking is not available for this panel.': 'تتبّع الزيارات غير متاح لهذه اللوحة.',
  'Conversion rate requires recorded visits.': 'تتطلب نسبة التحويل تسجيل الزيارات.',
  'Referred customers with a confirmed deposit.': 'العملاء المُحالون الذين أكملوا إيداعًا مؤكدًا.',
  'Available and reserved earnings after refund adjustments.': 'الأرباح المتاحة والمحجوزة بعد تسويات الاسترداد.',
  'Refunded commissions exceed current earnings. New earnings first cover this adjustment.': 'العمولات المستردة تتجاوز الأرباح الحالية. تغطي الأرباح الجديدة هذه التسوية أولًا.',
  'Enter a valid USD amount with at most two decimals.': 'أدخل مبلغًا صحيحًا بالدولار الأمريكي، بمنزلتين عشريتين على الأكثر.',
  'Minimum payout is USD 10.00 and cannot exceed available earnings.': 'الحد الأدنى للسحب 10 دولارات، ولا يجوز تجاوز الأرباح المتاحة.',
  'Request outcome is unknown. Retry the same request to check it safely.': 'نتيجة الطلب غير معروفة. أعد محاولة الطلب نفسه للتحقق منها بأمان.',
  '5% of confirmed USD deposits, excluding bonuses and fees. Each deposit is rounded down to a whole cent. Minimum payout: USD 10.00. Administrator approval is required.': 'العمولة 5% من الإيداعات المؤكدة بالدولار الأمريكي، باستثناء المكافآت والرسوم. تُقرّب عمولة كل إيداع إلى السنت الأدنى. الحد الأدنى للسحب 10 دولارات، وتلزم موافقة المسؤول.',
  'Refunds reverse commission, including commission already paid out. The first eligible referral is retained for 30 days before registration.': 'تعكس المبالغ المستردة العمولة، بما فيها العمولة المدفوعة سابقًا. تُحفظ أول إحالة مؤهلة لمدة 30 يومًا قبل التسجيل.',
};
